import { matchPath } from 'react-router';

import { ROUTES } from '@constants';

import { getTranslation, Log } from '@utils';

import { IAppState } from '@stores';

export interface IPageTitle {
	seo: string;
	visual: string;
	breadcrumb?: string;
}

interface ICatalogGenreParams {
	genre: string;
	page: string;
}

export const getPageTitle = (
	path: string,
	isRouteMatched: (url: string) => boolean,
	options?: {
		state?: IAppState;
		myLocales?: { [key: string]: string };
	},
): IPageTitle => {
	const { myLocales = null } = options ? options : {};
	const translationAppsDefaultTitle = getTranslation('base.utils.localization', myLocales)('defaultAppsTitle');
	const translationApps = getTranslation('base.utils.localization.appCatalog', myLocales)('apps');
	const translationAppsPlayFree = getTranslation('base.utils.localization.appCatalog', myLocales)('play-free');
	const translationAppsMy = getTranslation('base.utils.localization.appCatalog', myLocales)('appsMy');
	const translationAppsPopular = getTranslation('base.utils.localization.appCatalog', myLocales)('appsPopular');
	const translationAppsNew = getTranslation('base.utils.localization.appCatalog', myLocales)('appsNew');
	const translationMySeo = getTranslation('base.utils.localization', myLocales)('my-seo');
	const translationMy = getTranslation('base.utils.localization', myLocales)('my');

	// порядок имеет значение.
	try {
		if (isRouteMatched(ROUTES.CATALOG_POPULAR)) {
			return {
				seo: `${translationAppsPopular} - ${translationMySeo}`,
				visual: translationAppsPopular,
				breadcrumb: translationAppsPopular,
			};
		} else if (isRouteMatched(ROUTES.CATALOG_NEW)) {
			return {
				seo: `${translationAppsNew} - ${translationMySeo}`,
				visual: translationAppsNew,
				breadcrumb: translationAppsNew,
			};
		} else if (isRouteMatched(ROUTES.CATALOG_INSTALLED)) {
			const appsMyText = translationAppsMy;

			return {
				seo: `${appsMyText} - ${translationMySeo}`,
				visual: appsMyText,
				breadcrumb: appsMyText,
			};
		} else if (isRouteMatched(ROUTES.APP)) {
			const app = options?.state.appsByIdStore?.data?.apps || [];
			const currentAppTitle = app.length ? app[0].title : '';

			if (currentAppTitle.length) {
				return {
					seo: `${currentAppTitle} - ${translationAppsPlayFree}`,
					visual: currentAppTitle,
					breadcrumb: currentAppTitle,
				};
			} else {
				return {
					seo: '',
					visual: '',
				};
			}
		} else if (isRouteMatched(ROUTES.CATALOG_GENRE)) {
			const { params: { genre, page } } = matchPath<ICatalogGenreParams>(path, ROUTES.CATALOG_GENRE);
			const translationPage = getTranslation('base.utils.localization', myLocales)('page');
			const translationGenre = genre ? getTranslation('base.utils.localization.appCatalog', myLocales)(genre) : null;
			let seo;
			if (!page || page === '1') {
				seo = `${translationApps} ${translationGenre.toLowerCase()} - ${translationAppsPlayFree}`;
			} else {
				seo = `${genre ? translationGenre : translationMySeo} - ${translationPage} ${page}`;
			}

			return {
				seo,
				visual: translationApps,
				breadcrumb: translationGenre,
			};
		} else if (isRouteMatched(ROUTES.CATALOG)) {
			return {
				seo: translationAppsDefaultTitle,
				visual: translationApps,
				breadcrumb: translationApps,
			};
		}
	} catch (err) {
		Log.error(`Failed build page title: ${err}`);
	}

	return {
		seo: translationAppsDefaultTitle,
		visual: translationMy,
	};
};
